import gql from 'graphql-tag';

const giftTokenQuery = gql`
  query giftToken($token: String!) {
    giftToken(token: $token) {
      userId
      user {
        name
      }
      company {
        name
      }
    }
  }
`;

const inspectReloadableGiftingTokenQuery = gql`
  query inspectReloadableGiftingToken($token: String!, $noGift: Boolean) {
    getReloadableGiftingToken(token: $token, noGift: $noGift) {
      id
      currentEntityIsOwner
      gift {
        amount
      }
      userToken {
        token
      }
    }
  }
`;

export { giftTokenQuery, inspectReloadableGiftingTokenQuery };
